import SiteHeader from "./site-header";
import Redirects from "./redirects"

(() => {
  new SiteHeader();
  new Redirects();

  let lastWindowWidth = window.innerWidth;

  const scrollToAnchor = (anchorId, adjustScroll = false) => {
    const anchorElement = document.getElementById(anchorId);
    if (anchorElement) {
      let offsetPosition = anchorElement.getBoundingClientRect().top + window.pageYOffset;

      if (window.innerWidth > 768) {
        offsetPosition -= 118;
      } else {
        offsetPosition -= 68;
      }

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };

  document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', function (e) {
      e.preventDefault();
      const anchorId = this.getAttribute('href').substring(1);
      scrollToAnchor(anchorId);
    });
  });

  window.addEventListener('resize', () => {
    const currentWidth = window.innerWidth;
    if ((lastWindowWidth <= 768 && currentWidth > 768) || (lastWindowWidth > 768 && currentWidth <= 768)) {
      const currentAnchorId = window.location.hash.substring(1);
      if (currentAnchorId) {
        scrollToAnchor(currentAnchorId, true);
      }
    }
    lastWindowWidth = currentWidth;
  });

})();
